import type { Permission } from '@ztechapps/common.contract'

export const purchaseOrderPermissions = {
  canView: {
    value: 'purchaseOrder.canView',
    label: 'Can View',
    description: 'No modification can be done to the purchaseOrder, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'purchaseOrder.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of purchaseOrder',
  } satisfies Permission,
}
